import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { InfoModalComponent } from '../components/info-modal/info-modal.component';

@Injectable({ providedIn: 'root' })
export class InfoModalService {
  private modalRef?: BsModalRef;


  constructor(private modalService: BsModalService) {}

  confirm({
    title,
    message,
    closeOK,
  }: {
    title: string;
    message: string;
    closeOK?:string
  }): Observable<boolean> {
    const result = new Subject<boolean>();

    this.modalRef = this.modalService.show(InfoModalComponent, {
      initialState: { title, message, closeOK, result },
      class: 'modal-dialog-centered',
      ignoreBackdropClick: true,
      backdrop: true

    });
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    return result.asObservable();
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.hide();
      document.body.style.removeProperty('position');
    }
  }
}
